import BFLLink from "@repo/shared-ui/BFLLink";
import { handleFooterLinkClickDL } from "./FooterAccordionFunction";

interface ImportantLink {
  linkTitle?: string;
  linkUrl?: string;
  nodeName?: string;
  newTab?: string;
}

interface ImportantLinksProps {
  links: ImportantLink[];
  sectionTitle: string;
  isMobile: boolean;
}

const handleLinkClickEvent = (
  e: React.MouseEvent<HTMLElement>,
  linkTitle: string,
  sectionTitle: string,
  linkUrl: string
) => {
  e.preventDefault();
  handleFooterLinkClickDL(linkTitle, sectionTitle, linkUrl);
  window.location.href = linkUrl;
};

const ImportantLinks: React.FC<ImportantLinksProps> = ({ links, sectionTitle, isMobile }) => {
  return (
    <div className="flex w-full flex-wrap pt-2 text-sm">
      {links?.map((link, idx) => {
        const linkUrl = link.linkUrl || "#";
        const linkTitle = link?.linkTitle || "";

        return (
          <div
            key={link?.nodeName || linkTitle || idx}
            className={`my-1 box-border pr-2 leading-[19.2px] break-words ${isMobile ? "w-[50%]" : "w-[20%]"}`}
            style={{ width: isMobile ? "50%" : "20%" }}
          >
            <BFLLink
              href={linkUrl}
              className="block w-full"
              onClick={(e) => handleLinkClickEvent(e, linkTitle, sectionTitle, linkUrl)}
            >
              {linkTitle}
            </BFLLink>
          </div>
        );
      })}
    </div>
  );
};

export default ImportantLinks;
